import { css } from '@emotion/react';

import { typography2 } from '@coursera/cds-core';
import type { Theme } from '@coursera/cds-core';

export const articleBodyStyles = (theme: Theme) => css`
  & > .rc-RichText {
    ${theme.typography.h2}
    color: var(--cds-color-grey-975);

    .rc-Markdown {
      &.rc-ArticleTable {
        margin: 24px 0;

        @media (max-width: 767px) {
          overflow: scroll;
          height: 300px;
        }

        table {
          margin: unset;
          border-radius: 4px;
          ${typography2.bodySecondary}

          th, td {
            border: 0;
          }

          tr {
            height: 53px;
          }

          thead {
            tr {
              background-color: #dceef6;
              font-weight: bold;
            }
          }

          tr:nth-of-type(2n + 2) {
            background-color: #f5f5f5;
          }

          td {
            ul {
              max-width: fit-content;
              padding-right: 45px;

              li {
                text-align: start;
              }
            }
          }
        }
      }
    }

    ol,
    ul {
      padding-left: 45px;
      margin-left: 0;
      margin-bottom: 16px;
    }

    .vjs-menu-content {
      padding-left: 0;
      font-size: inherit;
      margin: 0;
    }

    li {
      p {
        ${theme.typography.h2}
        font-size: 18px;
        margin-top: 0;
        margin-bottom: 0;
      }
    }

    & > p {
      ${theme.typography.h2}
      font-size: 18px;
      margin-top: 24px;
      margin-bottom: 0;
    }

    & > h2 {
      ${theme.typography.h1semibold}
      font-size: 30px;
    }

    & > h3 {
      ${theme.typography.h2semibold}
      font-size: 24px
    }

    & > h4 {
      ${theme.typography.h2semibold}
      font-size: 20px;
    }

    & > h2,
    > h3,
    > h4 {
      margin-top: 3rem;
      margin-bottom: 0;
    }

    p > a {
      color: var(--cds-color-blue-700);
      text-decoration: underline;

      &:hover {
        text-decoration: none;
      }

      &:visited {
        color: var(--cds-color-purple-950);
      }
    }

    b,
    strong {
      ${theme.typography.h2semibold}
      font-size: inherit;
      line-height: inherit;
    }

    figure {
      width: 100%;
      margin-bottom: 0;

      img {
        margin-top: 3rem;
        width: 100%;
      }
    }

    figcaption {
      color: var(--cds-color-grey-600);
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      margin-top: 24px;
    }

    .rc-ArticleHighlight {
      p {
        margin-top: 10px;
      }
    }

    blockquote {
      align-items: start;
      margin: 48px 0 0 0;
      border-left: none;
      display: grid;
      position: relative;
      grid-template-columns: auto 90% auto;
      padding: 0 20px 0 40px;

      &::before {
        content: url('https://d2j5ihb19pt1hq.cloudfront.net/articles/svg/quote-left.svg');
        left: 40px;
        position: absolute;
      }

      &::after {
        padding-left: 5px;
        content: url('https://d2j5ihb19pt1hq.cloudfront.net/articles/svg/quote-right.svg');
        position: absolute;
        right: 20px;
      }

      p {
        ${theme.typography.h1}
        font-style: italic;
        padding: 0 8px 8px 8px;
        color: var(--cds-color-blue-900);
        grid-column: 2;
        margin-bottom: 0;
        margin-top: 0;

        b,
        strong {
          ${theme.typography.h1semibold}
        }

        @media screen and (max-width: 480px) {
          padding: 20px 0 0 0;
          line-height: 32px;
        }
      }

      @media screen and (max-width: 480px) {
        padding: 20px 0 0 0;

        &::before {
          left: 0;
        }

        &::after {
          right: 0;
        }
      }
    }
  }
`;
